import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { matchPath } from 'react-router-dom';
import moment from 'moment-timezone';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { toMilesPerHour, Unit } from '../../../helpers/unit';
import { updateReplayBox } from '../../../actions/map';
import { analyzeRecentSummary } from "../../../actions/analyze";
import {
    SpeedRange, CloseButton, Loading, ReplayKPIBox,
    toDisplayDateTime, toDisplayDate, toDisplayTime, SpeedRangeLabel
} from './utils';
import { ToggleSwitch } from '../../widgets';
import ReplayContext from './ReplayContext';
import RangeSelection from './RangeSelection';
import Player from './Player';
import TimeRange from './TimeRange';
import { isUUID, isAutomaticLoad, usePermission, getQueryParams, validateCollections } from '../../../helpers/common';
import { getSearchQueryData, getUserId } from '../../../helpers/session';
import {
    BALER_CATEGORYIDS, HARVESTING_CATEGORYIDS,
    DISPLAY_DATE_FORMAT2, API_DATETIME_FORMAT, TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR,
    PLANTER_CATEGORYIDS,
    API_DATE_FORMAT
} from '../../../constants';
import {
    STREAM_FETCHING, STREAM_FETCHED, PTO_FETCHING, PTO_FETCHED,
    LOAD_FETCHING, LOAD_FETCHED, BALE_FETCHED, BALE_FETCHING,
    EVENT_PLAYING, EVENT_LIVE_STREAM, EVENT_CLEAR_STREAM, EVENT_KPI, EVENT_SPEED_VARIATION, SPEED_VARIATION_FETCHING, SPEED_VARIATION_FETCHED
} from './GPSPlayer';
import "../../../../assets/scss/replay.scss";

const WS_REPLAY = "replay";

class ReplayBox extends Component {
    static contextType = ReplayContext;

    constructor(props) {
        super(props);

        this.unit = Unit.getInstance();
        this.isMessageReceiver = false;
        this.timezone = null;

        this.kpiBox = {
            acres: 0,
            loads: 0,
            bales: 0,
            avgSpeed: null,
            maxSpeed: null
        };

        this.state = {
            kpiBox: { ...this.kpiBox },
            speedVariation: [],
            refresh: 0,
            isFetching: false,
            range: null,
            dateRange: {
                start: null,
                end: null
            },
            time: {
                start: null,
                end: null
            },
            progressTime: null,
            firstLiveTime: null,
            domain: [],
            speed: null,
            isEnableArea: false,
            isEnablePTO: false,
            isEnableLoad: false,
            isEnableSeed: false,
            isEnableBale: false,
            isEnableSpeedVariation: false,
            isVisiblePTO: false,
            isVisibleLoad: false,
            isVisibleBale: false,
            isVisibleSpeedVariation: false,
            searchQuery: null,
            show: true
        };

        this.addEventListener = this.addEventListener.bind(this);
        this.getStream = this.getStream.bind(this);
        this.handleSelectDate = this.handleSelectDate.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem("storeGps")
        localStorage.removeItem("totalProcessingTime");
        localStorage.removeItem("totalAPIResponseTime");
        this.gpsPlayer = this.context.gpsPlayer;
        this.addEventListener();

        const { replay, selectedPlanType } = this.props;
        this.setState({
            speed: replay.speed,
            range: replay.range,
            time: replay.time,
            isEnablePTO: replay.isEnablePTO,
            isEnableLoad: replay.isEnableLoad,
            isEnableSeed: selectedPlanType === 2,
            isEnableBale: replay.isEnableBale,
            isEnableSpeedVariation: replay.isEnableSpeedVariation
        });

        const queryParameters = getQueryParams();
        const searchQuery = getSearchQueryData(queryParameters['searchId']);
        if (searchQuery) {
            this.setState({ searchQuery });
        }
    }

    addEventListener() {
        const me = this;
        this.gpsPlayer.addListener(STREAM_FETCHING, null, () => {
            this.setState({ isFetching: true, progressTime: null, firstLiveTime: null, kpiBox: { ...me.kpiBox }, speedVariation: [] });
        }).addListener(STREAM_FETCHED, null, ({ progressTime }) => {
            if (me.props.isAutoZoom) this.gpsPlayer.setBounds();
            this.setState({ isFetching: false, progressTime });
        }).addListener(EVENT_PLAYING, null, ({ progressTime }) => {
            this.setState({ progressTime });
        }).addListener(EVENT_LIVE_STREAM, null, ({ end }) => {
            if (!me.state.firstLiveTime) me.setState({ firstLiveTime: end });
        }).addListener(PTO_FETCHING, null, () => {
            this.setState({ isFetching: true });
        }).addListener(PTO_FETCHED, null, () => {
            this.setState({ isFetching: false });
        }).addListener(LOAD_FETCHING, null, () => {
            this.setState({ isFetching: true, kpiBox: { ...me.state.kpiBox, loads: 0 } });
        }).addListener(LOAD_FETCHED, null, () => {
            this.setState({ isFetching: false });
        }).addListener(BALE_FETCHING, null, () => {
            this.setState({ isFetching: true, kpiBox: { ...me.state.kpiBox, bales: 0 } });
        }).addListener(BALE_FETCHED, null, () => {
            this.setState({ isFetching: false });
        }).addListener(EVENT_CLEAR_STREAM, null, () => {
            this.setState({ isFetching: false, progressTime: null, firstLiveTime: null });
        }).addListener(EVENT_KPI, null, data => {
            if (data.acres) data.acres = this.unit.toRoundOfArea(data.acres);
            if (data.avgSpeed) data.avgSpeed = this.unit.toRoundOfSpeed(data.avgSpeed);
            if (data.maxSpeed) data.maxSpeed = this.unit.toRoundOfSpeed(data.maxSpeed);
            this.setState({ kpiBox: { ...this.state.kpiBox, ...data } });
        }).addListener(EVENT_SPEED_VARIATION, null, data => {
            const speedVariation = data.map(v => ({
                ...v,
                minSpeed: v.minSpeed && Math.ceil(this.unit.toRoundOfSpeed(v.minSpeed)),
                maxSpeed: v.maxSpeed && Math.ceil(this.unit.toRoundOfSpeed(v.maxSpeed))
            }));
            this.setState({ speedVariation });
        }).addListener(SPEED_VARIATION_FETCHING, null, () => {
            this.setState({ isFetching: true });
        }).addListener(SPEED_VARIATION_FETCHED, null, () => {
            this.setState({ isFetching: false });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const previous = prevProps.egList.map(e => e.egId).sort().join();
        const current = this.props.egList.map(e => e.egId).sort().join();
        const isChangedEG = this.props.replay.enable ? (previous !== current) : false;

        if (((prevProps.selectedPlanType !== this.props.selectedPlanType))) {
            this.setState({ ...this.state, isEnableSeed: this.props.selectedPlanType === 2 });
            this.gpsPlayer.enableLoad(this.state.isEnableLoad);
            this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
        }

        if (!isChangedEG && prevState.refresh === this.state.refresh) return;

        const isSubscribe = (this.state.range === 1);
        this.getStream(isSubscribe);

        if (this.state.searchQuery) {
            this.toggleLoad({ target: { checked: true } });
            this.setState({ searchQuery: null, speed: 100 });
        }
    }

    getStream = isSubscribe => {
        if (isSubscribe) this.unsubscribe();

        const egList = this.props.egList;
        let workedEGList = this.props.workedEGList ? this.props.workedEGList : [];
        workedEGList = workedEGList.map((e) => e.equipment_group_uuid);
        const filteredEgList = workedEGList.length > 0 ?
            egList.filter((e) => workedEGList.includes(e.egId)) : egList;

        if (filteredEgList.length === 0) {
            this.enableToggleV1(filteredEgList);
            return this.gpsPlayer.clearStream();
        }

        this.timezone = this.props.timezoneIdentifier;
        this.gpsPlayer.clear();
        this.enableToggleV1(filteredEgList);

        const match = this.getMatch();
        if (!match || !match.params) return;

        const { farmId, crewId } = match.params;
        const { startDate, endDate } = this.getDateRange();
        const regionId = this.props.regionId ? this.props.regionId : null;

        this.gpsPlayer
            .clear()
            .request({
                farmId,
                crewId: isUUID(crewId) ? crewId : null,
                regionId: isUUID(regionId) ? regionId : null,
                timezone: this.timezone, egList: filteredEgList,
                startDate: startDate.format(API_DATETIME_FORMAT),
                endDate: endDate.format(API_DATETIME_FORMAT)
            })
            .setSpeed(this.state.speed)
            .setOptions({
                isShowMarker: (this.state.speed > 0),
                markerLabel: this.props.mapDisplayId,
                weightShortName: this.props.settings.weightShortName
            })
            .enableSeed(this.props.selectedPlanType === 2)
            .setMapEG(this.props.mapEGList)
            .setFieldDistance(this.props.distanceList)
            .stream().then(() => {
                if (isSubscribe) this.subscribe();
            });
    }

    enableToggle(egList) {
        let state = {};

        // Speed variation enable
        const isSpeedVariationVisible = egList.length === 1;
        this.gpsPlayer.enableSpeedVariation(isSpeedVariationVisible && this.state.isEnableSpeedVariation);
        this.setState({ ...state, isVisibleSpeedVariation: isSpeedVariationVisible });

        // PTO enable
        const nonTruckEG = egList.filter(e => !e.isTruck);
        if (nonTruckEG.length > 0) {
            this.gpsPlayer.enablePTO(this.state.isEnablePTO);
            state = { ...state, isVisiblePTO: true };
        } else {
            this.gpsPlayer.enablePTO(false);
            state = { ...state, isVisiblePTO: false };
        }

        const categoryIds = this.props.selectedPlanType === 2 ? PLANTER_CATEGORYIDS : HARVESTING_CATEGORYIDS;

        // Load count enable
        const truckEG = egList.filter(e => e.isTruck);
        const loadEG = egList.filter(e => categoryIds.indexOf(e.categoryId) >= 0);

        if (isAutomaticLoad()) {
            if (truckEG.length > 0) {
                this.gpsPlayer.enableLoad(this.state.isEnableLoad);
                this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
                state = { ...state, isVisibleLoad: true };
            } else {
                this.gpsPlayer.enableLoad(false);
                this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
                state = { ...state, isVisibleLoad: false };
            }
        } else if (loadEG.length > 0) {
            this.gpsPlayer.enableLoad(this.state.isEnableLoad);
            this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
            state = { ...state, isVisibleLoad: true };
        } else {
            this.gpsPlayer.enableLoad(false);
            this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
            state = { ...state, isVisibleLoad: false };
        }

        // Bale count enable
        const balerEG = egList.filter(e => BALER_CATEGORYIDS.indexOf(e.categoryId) >= 0);
        if (balerEG.length > 0) {
            this.gpsPlayer.enableBale(this.state.isEnableBale);
            state = { ...state, isVisibleBale: true };
        } else {
            this.gpsPlayer.enableBale(false);
            state = { ...state, isVisibleBale: false };
        }

        // Acres enable
        if (nonTruckEG.length === 0 || (egList.length > 0 && balerEG.length === egList.length)) {
            this.gpsPlayer.enableArea(false);
            state = { ...state, isEnableArea: false };
        } else if (nonTruckEG.length > 0) {
            this.gpsPlayer.enableArea(true);
            state = { ...state, isEnableArea: true };
        }

        // Enable Seed plantype
        this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
        this.setState(state);
    }

    enableToggleV1(egList) {
        let state = {};

        // Speed variation enable
        const isSpeedVariationVisible = egList.length === 1;
        this.gpsPlayer.enableSpeedVariation(isSpeedVariationVisible && this.state.isEnableSpeedVariation);
        this.setState({ ...state, isVisibleSpeedVariation: isSpeedVariationVisible });

        // PTO enable
        const nonTruckEG = egList.filter(e => !e.isTruck);
        if (nonTruckEG.length > 0) {
            this.gpsPlayer.enablePTO(this.state.isEnablePTO);
            state = { ...state, isVisiblePTO: true };
        } else {
            this.gpsPlayer.enablePTO(false);
            state = { ...state, isVisiblePTO: false };
        }

        const categoryIds = this.props.selectedPlanType === 2 ? PLANTER_CATEGORYIDS : HARVESTING_CATEGORYIDS;

        // Load count enable
        const truckEG = egList.filter(e => e.isTruck);
        const loadEG = egList.filter(e => categoryIds.indexOf(e.categoryId) >= 0);

        if (truckEG.length > 0 || loadEG.length > 0) {
            this.gpsPlayer.enableLoad(this.state.isEnableLoad);
            this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
            state = { ...state, isVisibleLoad: true };
        } else {
            this.gpsPlayer.enableLoad(false);
            this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
            state = { ...state, isVisibleLoad: false };
        }

        // Bale count enable
        const balerEG = egList.filter(e => BALER_CATEGORYIDS.indexOf(e.categoryId) >= 0);
        if (balerEG.length > 0) {
            this.gpsPlayer.enableBale(this.state.isEnableBale);
            state = { ...state, isVisibleBale: true };
        } else {
            this.gpsPlayer.enableBale(false);
            state = { ...state, isVisibleBale: false };
        }

        // Acres enable
        if (nonTruckEG.length === 0 || (egList.length > 0 && balerEG.length === egList.length)) {
            this.gpsPlayer.enableArea(false);
            state = { ...state, isEnableArea: false };
        } else if (nonTruckEG.length > 0) {
            this.gpsPlayer.enableArea(true);
            state = { ...state, isEnableArea: true };
        }

        // Enable Seed plantype
        this.gpsPlayer.enableSeed(this.props.selectedPlanType === 2);
        this.setState(state);
    }

    getDateRange = () => {
        if (this.state.speed > 0 || this.state.time.start === null || this.state.time.end === null)
            return {
                startDate: this.state.dateRange.start.clone(),
                endDate: this.state.dateRange.end.clone()
            };
        const splittedPath = window.location.pathname.split("/crew");
        const isCrewView = window.location.pathname.includes("crew") && splittedPath[splittedPath.length - 1] !== "";
        const isEgView = window.location.pathname.includes("eg") && this.state.isVisibleSpeedVariation;
        const isFarmLevel = isCrewView ? (!isCrewView) : isEgView ? (!isEgView) : true;
        const start = moment(this.state.dateRange.start.format(API_DATE_FORMAT));
        const end = moment(this.state.dateRange.end.format(API_DATE_FORMAT));
        const isSameRange = start.isSame(end);
        const date = this.state.dateRange.start.clone().startOf("day");
        const min = this.state.time.start ? this.state.time.start : 0;
        const max = !isSameRange && isFarmLevel ? (48 * 60) : this.state.time.end ? this.state.time.end : (24 * 60);
        const startDate = date.clone().add(min, "minutes");
        const endDate = date.clone().add(max, "minutes");
        return { startDate, endDate };
    }

    handleSpeed = speed => {
        if (speed > 0) {
            this.gpsPlayer.setSpeed(speed);
            this.setState({
                speed, time: { start: null, end: null },
                refresh: (speed !== this.state.speed && this.state.speed < 0) ?
                    this.state.refresh + 1 : this.state.refresh
            });
        }
        else {
            this.gpsPlayer.reset().setSpeed(speed);
            this.setState({
                speed,
                ...!(this.state.time.start && this.state.time.end) ? {
                    time: {
                        start: this.state.domain.length > 0 ? this.state.domain[0] : null,
                        end: this.state.domain.length > 0 ? this.state.domain[1] : null
                    }
                } : {},
                refresh: (speed !== this.state.speed) ?
                    this.state.refresh + 1 : this.state.refresh
            });
        }
    }

    handleSelectDate = (range, dateRange, isInitial) => {
        if (!(dateRange && dateRange.start && dateRange.end)) return;
        if (range !== 1) this.unsubscribe();

        const { min, max } = isInitial ? this.props.replay.time : this.getSliderRange(range, dateRange);
        this.setState({
            range, dateRange,
            domain: [min, max],
            time: { start: min, end: max },
            refresh: (dateRange.start === this.state.dateRange.start && dateRange.end === this.state.dateRange.end) ?
                this.state.refresh : this.state.refresh + 1
        });
    }

    handleTimeUpdate = ({ min, max }) => {
        this.setState({ time: { start: min, end: max } });
    }

    getSliderRange(range, dateRange) {
        let max = 1;
        if (range === 1) max = dateRange && dateRange.end ?
            (dateRange.end.hours() + (dateRange.end.hours() < 24 ? 1 : 0)) * 60 : 1;
        else if (dateRange && dateRange.start && dateRange.end) {
            max = dateRange.end.clone().diff(dateRange.start, "minutes");
        }
        else max = (24 * 60);
        return { min: 0, max: max > 0 ? max : 1 };
    }

    subscribe = () => {
        this.addReceiver();
        if (!this.ws) return;

        // const topics = [];
        // this.props.egList.forEach(item => {
        //     if (item.deviceId) {
        //         // topics.push({ deviceId: item.deviceId, action: TOPIC_LATEST_EG_SENSOR, parameters: { sensor: "gps", equipment_group_uuid: item.egId } });
        //         topics.push({ deviceId: item.deviceId, name: TOPIC_SENSOR, parameters: { sensor_type: "gps" } });
        //     }
        // });
        // if (topics.length > 0) this.ws.subscribe(topics, WS_REPLAY);
    }

    unsubscribe = () => {
        this.removeReceiver();
        // if (this.ws) this.ws.unsubscribe(WS_REPLAY);
    }

    addReceiver = () => {
        if (!this.ws) this.ws = window.socketClient;
        if (!this.ws) return;
        if (this.isMessageReceiver) return;

        this.ws.addMessageReceiver(WS_REPLAY, [TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR], live => {
            if (!(live && live.message)) return;
            if ([TOPIC_SENSOR, TOPIC_LATEST_EG_SENSOR].indexOf(live.name) >= 0)
                return this.handleQPresent(live, live.message);
        });
        this.isMessageReceiver = true;
    }

    removeReceiver = () => {
        if (this.ws) this.ws.removeMessageReceiver(WS_REPLAY);
        this.isMessageReceiver = false;
    }

    handleQPresent = live => {
        try {
            const { message, deviceId } = live;
            const egItem = this.getEgItem(deviceId);
            if (!egItem) return;

            const gps = message.hasOwnProperty('gps') ? message.gps.data : message;
            if (!(gps && gps.lat && gps.lng)) return;

            if (this.gpsPlayer.playerEndTime >= gps.ts) return;
            if (!this.gpsPlayer.endUTCDate) return;

            const endts = this.gpsPlayer.endUTCDate.valueOf();
            if (endts < gps.ts) return;

            const isSkip = (this.state.speed > 0) ?
                (this.gpsPlayer.leftDuration >= this.gpsPlayer.getTotalDuration()) : true;
            this.gpsPlayer.push({
                egId: egItem.egId,
                point: { lat: gps.lat, lng: gps.lng },
                accuracy: gps.accuracy,
                speed: toMilesPerHour(gps.speed),
                ts: gps.ts
            });
            if (isSkip) this.gpsPlayer.skip(gps.ts);
        } catch (ex) {
            console.log(ex.message);
        }
    }

    getEgItem = deviceId => {
        const findItems = this.props.egList.filter(e => e.deviceId === deviceId);
        return findItems.length > 0 ? findItems[0] : null;
    }

    togglePTO(e) {
        this.gpsPlayer.enablePTO(e.target.checked);
        this.setState({ isEnablePTO: e.target.checked });
    }

    toggleLoad(e) {
        const isEnableSeed = this.props.selectedPlanType === 2;
        // this.gpsPlayer.clear();

        const isSubscribe = (this.state.range === 1);
        this.getStream(isSubscribe);
        this.gpsPlayer.enableSeed(isEnableSeed);
        this.gpsPlayer.enableLoad(e.target.checked);
        this.setState({ isEnableLoad: e.target.checked, isEnableSeed });
    }

    toggleSpeedVariation(e) {
        this.gpsPlayer.enableSpeedVariation(e.target.checked, true);
        this.setState({ isEnableSpeedVariation: e.target.checked });
    }

    toggleBale(e) {
        this.gpsPlayer.enableBale(e.target.checked);
        this.setState({ isEnableBale: e.target.checked });
    }

    componentWillUnmount() {
        this.unsubscribe();
        this.props.actions.updateReplayBox({
            isEnablePTO: this.gpsPlayer.isEnablePTO,
            isEnableLoad: this.gpsPlayer.isEnableLoad,
            isEnableSeed: this.gpsPlayer.isEnableSeed,
            isEnableBale: this.gpsPlayer.isEnableBale,
            isEnableSpeedVariation: this.gpsPlayer.isEnableSpeedVariation,
            speed: this.state.speed,
            range: this.state.range,
            dateRange: this.state.dateRange
        });
    }

    getDisplayDate() {
        const timezone = this.timezone ? this.timezone : this.props.timezoneIdentifier;
        const { time, dateRange, speed, progressTime } = this.state;

        let displayDate = "", displayTime = "";
        if (speed === -1 && time.start !== null && time.end !== null) {
            const { startDate, endDate } = this.getDateRange();
            if (endDate.diff(startDate, "hours") < 24)
                displayDate = `${toDisplayDateTime(startDate)} to ${toDisplayTime(endDate)}`;
            else
                displayDate = `${toDisplayDateTime(startDate)} to ${toDisplayDateTime(endDate)}`;
        } else if (speed > 0 && dateRange.start && dateRange.end) {
            if (dateRange.end.diff(dateRange.start, "hours") < 24) {
                displayDate = `${toDisplayDate(dateRange.start)}`;
                if (progressTime) displayTime = `${moment.utc(progressTime).tz(timezone).format("hh:mm:ss a")}`;
            }
            else {
                displayDate = `${toDisplayDate(dateRange.start)} to ${toDisplayDate(dateRange.end)}`;
                if (progressTime) displayTime = `${moment.utc(progressTime).tz(timezone).format(`${DISPLAY_DATE_FORMAT2} hh:mm:ss a`)}`;
            }
        }

        return { displayDate, displayTime };
    }

    getMatch() {
        return matchPath(window.location.pathname, {
            path: `/home/farm/:farmId/map/(crew)?/:crewId?`,
            exact: false,
            strict: false
        });
    }

    render() {
        const timezone = this.timezone ? this.timezone : this.props.timezoneIdentifier;
        const { onClose } = this.context;
        const { replay } = this.props;
        const { isFetching, time, range, dateRange, domain, speed,
            isVisiblePTO, isVisibleLoad, isVisibleBale, isVisibleSpeedVariation, progressTime, firstLiveTime } = this.state;
        const { displayDate, displayTime } = this.getDisplayDate();
        const live = (range === 1) ? (progressTime && firstLiveTime) ? (progressTime > firstLiveTime) : false : null;
        const allow = usePermission();
        const isAllowEGTravelledDistance = allow("eg-travelled-distance", "view") ? true : false;
        const isAllowPto = allow('replay-pto', "view") ? true : false;
        let storedGpsCall = JSON.parse(localStorage.getItem("storeGps"));
        const processTime = localStorage.getItem("totalProcessingTime");
        const totalApiResponseTime = localStorage.getItem("totalAPIResponseTime");
        const isDeveloper = [541].includes(getUserId());
        return (
            <div className={"wrapper"}>
                {isFetching && <Loading />}
                {isDeveloper && this.state.show && <Card className='mb-3 w-50 mx-auto' >
                    <Card.Header className='d-flex align-items-center justify-content-between'>
                        <Card.Title>GPS Performance</Card.Title>
                        <section className='d-flex align-items-center' style={{ cursor: "pointer" }}>
                            <Button variant='light'
                                className="mr-2"
                                onClick={() => {
                                    localStorage.removeItem("storeGps")
                                    localStorage.removeItem("totalProcessingTime");
                                    localStorage.removeItem("totalAPIResponseTime");
                                    storedGpsCall = [];
                                }}>Clear</Button>
                            <div className="card-close" title="Close" onClick={() => {
                                this.setState({ show: false });
                            }}>
                                <i className="fa fa-times" />
                            </div>
                        </section>
                    </Card.Header>
                    <Card.Body style={{ maxHeight: 470, overflow: "hidden", overflowY: "auto" }}>

                        {validateCollections(storedGpsCall) && storedGpsCall.map((it, index) =>
                            <div key={`gps-call-${index}`} className='p-1 text-black-50 '>{`Gps request ${index + 1} ==> ${it}s`}</div>)}
                        {totalApiResponseTime ? <div>
                            <hr />
                            <div className='p-1 text-black-50'>{`Total API response time ==> ${totalApiResponseTime}s`}</div>
                        </div> : null}


                        {processTime ? <>
                            <hr />
                            <div className='p-1 text-black-50 '>{`Total processing time at the component level ==> ${processTime}s`}</div></> : null}
                        {isFetching && <div className='pl-2 text-black-50'>Loading...</div>}
                    </Card.Body>
                </Card>}

                <div>
                    <Row>
                        <Col md={9} xl={9} lg={9} className="position-relative">
                            {!isFetching && this.state.isEnableSpeedVariation && <SpeedRangeLabel settings={this.props.settings} speedvariation={this.state.speedVariation} />}
                        </Col>
                        <Col md={3} xl={3} lg={3}>
                            {!isFetching && <ReplayKPIBox settings={this.props.settings} kpiData={{
                                ...this.state.kpiBox,
                                isArea: this.state.isEnableArea,
                                isSpeed: (this.props.egList.length === 1),
                                isLoad: this.state.isEnableLoad,
                                isBale: this.state.isEnableBale
                            }} />}
                        </Col>
                    </Row>
                </div>
                <Row className={`content replay-box-container ${speed > 0 ? 'player' : 'timer'}`}>
                    <Col md={12} className="px-0">
                        <Row className="mx-0">
                            <div className="d-block d-xl-flex px-0 px-xl-2 w-100 justify-content-center justify-content-xl-between text-center">
                                <div className='replay-dtime-container'>
                                    {range && timezone && (
                                        <RangeSelection
                                            timezone={timezone}
                                            defaultRange={replay.range}
                                            onChange={this.handleSelectDate}
                                            calendar={{
                                                maxSelectDays: 10,
                                                defaultDate: replay.dateRange,
                                                enabledDate: replay.enabledDate,
                                            }}
                                        />
                                    )}
                                    {isAllowEGTravelledDistance && <div className="toggle-checkbox mt-2">
                                        <ToggleSwitch
                                            onChange={(e) => {
                                                e.target.checked
                                                    ? this.props.replayEGListControl.open()
                                                    : this.props.replayEGListControl.close();
                                            }}
                                            defaultChecked={false}
                                        />
                                        <label>Travelled Distance</label>
                                    </div>}
                                </div>
                                <div className="d-flex justify-content-center justify-content-xl-end float-xl-right">
                                    <SpeedRange speed={speed} onSelect={this.handleSpeed} />
                                    <CloseButton onClick={onClose} />
                                </div>
                            </div>
                        </Row>
                        <Row className="mx-0 pt-2 pb-2 mb-2">
                            <Col md={6} className="px-0 replay-time-container">
                                {displayDate && <span className="date-text">
                                    <b>{displayDate}</b>
                                </span>}
                                {displayTime && <span className="date-text replay-display-time">
                                    {displayTime}
                                </span>}
                                {live !== null &&
                                    <span className={`live-text ${live ? "active" : ""}`}>
                                        <i className="fa fa-circle" aria-hidden="true" /> LIVE
                                    </span>}
                            </Col>
                            <Col md={6} className="px-0">
                                <div className="d-flex snail-trail-options">
                                    {isAllowPto && <div className="toggle-checkbox first-checkbox" style={{ display: isVisiblePTO ? "block" : "none" }}>
                                        <ToggleSwitch
                                            onChange={this.togglePTO.bind(this)}
                                            defaultChecked={replay.isEnablePTO}
                                        />
                                        <label>PTO</label>
                                    </div>}
                                    <div className="toggle-checkbox" style={{ display: isVisibleBale ? "block" : "none" }}>
                                        <ToggleSwitch
                                            onChange={this.toggleBale.bind(this)}
                                            defaultChecked={replay.isEnableBale}
                                        />
                                        <label>Bale</label>
                                    </div>
                                    <div className="toggle-checkbox" style={{ display: isVisibleLoad ? "block" : "none" }}>
                                        <ToggleSwitch
                                            onChange={this.toggleLoad.bind(this)}
                                            checked={this.state.isEnableLoad}
                                        />
                                        <label>Load</label>
                                    </div>
                                    <div className="toggle-checkbox" style={{ display: isVisibleSpeedVariation ? "block" : "none" }}>
                                        <ToggleSwitch
                                            onChange={this.toggleSpeedVariation.bind(this)}
                                            defaultChecked={replay.isEnableSpeedVariation}
                                        />
                                        <label>Speed Variation</label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {domain.length > 0 && speed === -1 &&
                            <TimeRange
                                values={[time.start, time.end]}
                                domain={domain}
                                dateRange={dateRange}
                                fetchStream={this.getStream}
                                onUpdate={this.handleTimeUpdate}
                                isAutoZoom={this.props.isAutoZoom}
                            />}
                        {dateRange.start && dateRange.end && speed > 0 &&
                            <Player
                                timezone={timezone}
                                dateRange={dateRange}
                            />}
                    </Col>
                </Row>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
    isAutoZoom: state.map.isAutoZoom,
    egList: state.map.filteredEgList,
    mapEGList: state.map.egList,
    distanceList: state.distance.distanceList,
    mapDisplayId: state.user.settings.mapDisplayId,
    replay: state.map.replay,
    selectedPlanType: state.plan.selectedPlanType,
    settings: {
        weightShortName: state.user.settings.weightShortName,
        speedShortName: state.user.settings.speedShortName,
    },
    regionId: state.analyze.analyzeParams.regionId,
    workedEGList: state.geo.workedEG.payload
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ updateReplayBox, analyzeRecentSummary }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplayBox);
